import {
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter,
  faClone,
  faXmarkLarge,
} from '@fortawesome/pro-light-svg-icons';
import { Widget } from './widget';
import type { CustomWidget } from '../../providers/model/custom-widget';

type WidgetActions = {
  handleMaximizeWidget?: (id: string) => void;
  handleDuplicateWidget?: (id: string) => void;
  handleCloseWidget?: (id: string) => void;
};

export type WidgetPermissions = {
  canDelete?: boolean;
  canDuplicate?: boolean;
};

interface WidgetButtonsProps {
  widget: CustomWidget;
  actions?: WidgetActions;
  permissions?: WidgetPermissions;
}

const WidgetButtons = ({ widget, actions, permissions }: WidgetButtonsProps) => {
  const id = widget.id || widget.key;

  const canDuplicate = permissions?.canDuplicate !== false;
  const canDelete = permissions?.canDelete !== false;

  const maximizedIcon = widget.isMaximized
    ? faArrowDownLeftAndArrowUpRightToCenter
    : faArrowUpRightAndArrowDownLeftFromCenter;

  return (
    <>
      <Widget.Button icon={maximizedIcon} onClick={() => actions?.handleMaximizeWidget?.(id)} />
      {canDuplicate && (
        <Widget.Button icon={faClone} onClick={() => actions?.handleDuplicateWidget?.(id)} />
      )}
      {canDelete && (
        <Widget.Button icon={faXmarkLarge} onClick={() => actions?.handleCloseWidget?.(id)} />
      )}
    </>
  );
};

export default WidgetButtons;
